export default "__VITE_ASSET__DYirW3y0__"